import { Grid } from '@mui/material';
import TheGuarantorsLogo from '../../assets/images/TheGuarantors_Logo.svg';

export const TermsCopyrightCompliance = () => {
  return (
    <>
      <div>
        <p className="c15">
            <img
              alt=""
              src={TheGuarantorsLogo}
              title=""
            />
        </p>
        <p className="c12">
          <span className="c6 c7"></span>
        </p>
      </div>
      <p className="c19">
        <span className="c1 c5">
          TheGuarantors Renter&rsquo;s Insurance Verification
        </span>
      </p>
      <p className="c19">
        <span className="c5 c1">Tenant Terms and Conditions</span>
      </p>
      <p className="c16">
        <span className="c6 c0">Last Modified: April 11, 2023</span>
      </p>
      <p className="c3 c8">
        <span className="c0">1.</span>
        <span className="c0 c9">&nbsp; &nbsp; &nbsp;</span>
        <span className="c10 c11 c1">
          Acceptance of the Terms and Conditions.
        </span>
      </p>
      <p className="c3">
        <span className="c0">
          These Terms and Conditions are entered into by and between You
          (&ldquo;You&rdquo;) and GuarantR, Inc., d/b/a TheGuarantors (&quot;
        </span>
        <span className="c1">Company</span>
        <span className="c0">,&quot; &quot;</span>
        <span className="c1">we</span>
        <span className="c0">,&quot; or &quot;</span>
        <span className="c1">us</span>
        <span className="c0">
          &quot;). The following terms and conditions (&ldquo;
        </span>
        <span className="c1">Terms and Conditions</span>
        <span className="c6 c0">
          &rdquo;) govern Your access to and use of TheGuarantors Renter&rsquo;s
          Insurance and Compliance Platform, including any content,
          functionality, and services offered on or through the platform (the
          &ldquo;Platform&rdquo;).
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          Please read the Terms and Conditions carefully before You start to use
          the Platform. This Agreement is a binding agreement between You and
          Company. This Agreement governs Your use of the Platform, including
          any products installed on the Platform, including all upgrades,
          patches, modified versions, updates, and additional features and
          functionality to the software, if any, provided to You, and any
          optional add-on module or packages. If You have any questions
          concerning the permitted uses of the Platform, You should contact
          Company for clarification. You shall be responsible for all hardware
          and/or network connectivity required to access or use the Platform.
        </span>
      </p>
      <p className="c3">
        <span className="c1">
          By using this Platform, You agree to be bound and abide by these Terms
          and Conditions and our Privacy Policy, found at
          https://www.theguarantors.com/privacy, incorporated herein by
          reference. You consent to Company collecting, using, and retaining the
          information You provide herein, and the sharing of such information as
          required to provide the services.{' '}
        </span>
        <span className="c6 c0">
          &nbsp;If You do not want to agree to these Terms and Conditions or the
          Privacy Policy, You must not access or use the Platform.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          This Platform is offered and available to users who 18 years of age or
          older. By using this Platform, You represent and warrant that You are
          of legal age to form a binding contract with the Company and meet all
          of the foregoing eligibility requirements. If You do not meet all of
          these requirements, You must not access or use the Platform.
        </span>
      </p>
      <p className="c3 c8">
        <span className="c0">2.</span>
        <span className="c0 c9">&nbsp; &nbsp; &nbsp;</span>
        <span className="c10 c11 c1">Changes to the Terms and Conditions.</span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          We may revise and update these Terms and Conditions from time to time
          in our sole discretion. All changes are effective immediately when we
          post them, and apply to all access to and use of the Platform
          thereafter. Your continued use of the Platform following the posting
          of revised Terms and Conditions means that You accept and agree to the
          changes. You are expected to check this page from time to time so You
          are aware of any changes, as they are binding on You.
        </span>
      </p>
      <p className="c3 c8">
        <span className="c0">3.</span>
        <span className="c0 c9">&nbsp; &nbsp; &nbsp;</span>
        <span className="c10 c11 c1">The Platform and Intended Use.</span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          Company provides this Platform product which collects, collates,
          monitors, reports, and processes information regarding Your renter
          insurance policies to determine if Your insurance coverage complies
          with requirements set by Your landlord(s). As a tenant, You have the
          option to either upload a PDF of Your renter&rsquo;s insurance policy,
          or to follow a link to a third-party service provider where You may be
          asked to log-in to Your insurance provider&rsquo;s application or
          webpage account with Your username and password. Company will process
          Your renter&rsquo;s insurance policy information from such application
          or webpage and share the relevant information with Your landlord.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          By using this Platform, You represent and warrant that You shall only
          use the Platform, and the features within, for its intended purposes.
          You shall at all times comply with the terms outlined throughout these
          Terms and Conditions. Company maintains the right to terminate or
          suspend Your access to all or part of the Platform for any or no
          reason, including without limitation, any violation of these Terms and
          Conditions.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          Company provides no guarantees concerning insurance coverage.
          Specifically, if Company verifies Your insurance coverage, it does not
          guarantee (a) that all of Your insurance obligations are fulfilled
          between You and Your landlord or any other third party; or (b) the
          enforceability, coverage, or terms of the third-party insurance policy
          that You maintain. For more information about Your insurance coverage
          and whether it meets Your renter&rsquo;s insurance obligations, please
          review Your insurance policy or contact Your insurance provider.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">4.</span>
        <span className="c0 c9">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span className="c10 c11 c1">Restrictions and Prohibited Uses.</span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          The Platform and its entire contents, features, and functionality
          (including but not limited to all information, software, text,
          displays, images, video, and audio, and the design, selection, and
          arrangement thereof) are owned by the Company, its licensors, or other
          providers of such material and are protected by United States and
          international copyright, trademark, patent, trade secret, and other
          intellectual property or proprietary rights laws. These Terms and
          Conditions permit You to use the Platform for Your personal,
          non-commercial use only. You must not reverse engineer, reproduce,
          distribute, modify, create derivative works of, publicly display,
          publicly perform, republish, download, store, or transmit any of the
          material on our Platform, except as follows: (a) Your computer may
          temporarily store copies of such materials in RAM incidental to Your
          accessing and viewing those materials; (b) You may store files that
          are automatically cached by Your Web browser for display enhancement
          purposes; and (c) You may print or download one copy of a reasonable
          number of pages of the Platform for Your own personal, non-commercial
          use and not for further reproduction, publication, or distribution.
          You must not: (a) modify copies of any materials from this site; (b)
          delete or alter any copyright, trademark, or other proprietary rights
          notices from copies of materials from this Platform; and (c) You must
          not access or use for any commercial purposes any part of the Platform
          or any services or materials available through the Platform. If You
          print, copy, modify, download, or otherwise use or provide any other
          person with access to any part of the Platform in breach of these
          Terms and Conditions, Your right to use the Platform will stop
          immediately and You must, at our option, return or destroy any copies
          of the materials You have made. No right, title, or interest in or to
          the Platform or any content on the Platform is transferred to You, and
          all rights not expressly granted are reserved by the Company. Any use
          of the Platform not expressly permitted by these Terms and Conditions
          is a breach of these Terms and Conditions and may violate copyright,
          trademark, and other laws.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          In addition, You agree not to engage in activities when using the
          Platform that (i) violate the law, regulation, rule, court verdicts,
          resolutions or orders, or administrative measures that are legally
          binding; (ii) may hinder public order or customs; (iii) infringe
          intellectual property rights, such as copyrights, trademarks and
          patents, fame, privacy, and all other rights of Company and/or a third
          party granted by the law or contract; (iv) could disable, overburden,
          damage, or impair the site or interfere with any other party&#39;s use
          of the Platform, including their ability to engage in real time
          activities through the Platform; (v) use any robot, spider, or other
          automatic device, process, or means to access the Platform for any
          purpose, including monitoring or copying any of the material on the
          Platform; (vi) use any manual process to monitor or copy any of the
          material on the Platform, or for any other purpose not expressly
          authorized in these Terms and Conditions, without our prior written
          consent; (vii) use any device, software, or routine that interferes
          with the proper working of the Platform; (viii) introduce any viruses,
          Trojan horses, worms, logic bombs, or other material that is malicious
          or technologically harmful; (ix) attempt to gain unauthorized access
          to, interfere with, damage, or disrupt any parts of the Platform, the
          server on which the Platform is stored, or any server, computer, or
          database connected to the Platform; (x) attack the Platform via a
          denial-of-service attack or a distributed denial-of-service attack;
          (xi) post or transmit any objectionable content including, but not
          limited to, violent or sexual expressions, expressions that lead to
          discrimination by race, national origin, creed, sex, social status,
          family origin, etc.; (xii) is for the purpose of exploiting, harming,
          or attempting to exploit or harm minors in any way by exposing them to
          inappropriate content, asking for personally identifiable information,
          or otherwise; (xiii) could lead to the misrepresentation of the
          Company and/or a third party, or intentionally spread false
          information; (xiv) to impersonate or attempt to impersonate the
          Company, a Company employee, another user, or any other person or
          entity (including, without limitation, by using email addresses
          associated with any of the foregoing); (xv) interfere with
          Company&rsquo;s servers and/or network systems either related or
          unrelated to the Platform, such activities that abuse the Platform
          and/or servers and/or network systems, either related or unrelated to
          the Platform, by means of BOTs, cheat tools, or other technical
          measures; (xvi) exchange the right to use the Platform into cash,
          property or other economic benefits without Company&rsquo;s
          authorization; (xvii) use the Platform for sales, marketing,
          advertisement, soliciting or other commercial purposes or to transmit,
          or procure the sending of, any advertising or promotional material,
          including any &quot;junk mail,&quot; &quot;chain letter,&quot;
          &quot;spam,&quot; or any other similar solicitation; or (xviii) other
          activities that may be deemed by Company to be inappropriate or that
          restrict or inhibit anyone&rsquo;s use or enjoyment of the Platform.
          Company shall have the sole and exclusive right to determine whether
          You have engaged in any of these restricted activities and to
          determine whether this Agreement with You should be terminated.
        </span>
      </p>
      <p className="c3 c8">
        <span className="c0">5.</span>
        <span className="c0 c9">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span className="c10 c11 c1">
          Proprietary Rights and Reservation of Rights.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          You hereby acknowledge and agree that: (a) the Platform, any content
          therein, and copies thereof are the exclusive proprietary technology
          and materials of Company (and/or Company&rsquo;s third party
          licensors, as may be appropriate) and are protected by copyright laws
          and international treaties as well as other intellectual property
          laws; (b) Company (and/or Company&rsquo;s third party licensors, as
          may be appropriate) shall retain all ownership rights in and to the
          Platform and any and all patents, copyrights, trade secrets and other
          proprietary rights relating thereto; (c) You have no right, title, or
          interest in the Platform under this Agreement, or any other rights
          thereto other than to access and use the Platform in accordance with
          these Terms and Conditions; (d) Company (and/or Company&rsquo;s third
          party licensors, as may be appropriate) reserves and shall retain all
          rights not expressly granted to You including Company&rsquo;s entire
          right, title, and interest in and to the Platform, copies of the
          Platform, and in all related copyrights, trade secrets, patents,
          trademarks, service marks, domain names and any other intellectual
          property and proprietary rights therein or relating thereto, including
          but not limited to any registrations, applications, renewals, and
          extensions of such rights, except as expressly granted to You in these
          Terms and Conditions; (e) any unauthorized copies, modifications,
          translations, adaptations, derivative works, or improvements of the
          Platform or components thereof shall be exclusively owned by Company,
          and You hereby (i) assign and shall assign any and all rights, title,
          and interests in the foregoing to Company, (ii) will promptly sign any
          other documents necessary to perfect Company&rsquo;s rights in and to
          the foregoing, and (iii) expressly waive any rights You may obtain
          inconsistent with the foregoing through application of law or
          otherwise; (f) You shall safeguard the Platform (including all copies
          thereof) from misappropriation, theft, misuse, unauthorized access and
          unauthorized use and You shall promptly notify Company if You become
          aware of any such misappropriation, theft, misuse, unauthorized access
          or unauthorized use and fully cooperate with Company, at
          Company&rsquo;s sole expense, in any legal action taken by Company to
          enforce its rights in and to the Platform; (g) You hereby covenant
          that You will not assert any claim that the Platform, components
          thereof, modifications or derivative works thereof created by or for
          Company infringe any intellectual property right owned or controlled
          by You.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">6.</span>
        <span className="c0 c9">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span className="c10 c11 c1">Updates.</span>
      </p>
      <p className="c4">
        <span className="c0">
          You agree that Company has no obligation to provide updates to the
          Platform, which may include upgrades, bug fixes, patches, enhancements
          and other error corrections and/or new features, maintenance,
          technical or other support for the Application (collectively,
          including related documentation, &ldquo;
        </span>
        <span className="c10 c0">Updates</span>
        <span className="c6 c0">
          &rdquo;), or to continue to provide or enable any particular features
          or functionality. Company may from time to time, however, in its sole
          discretion, develop and make Updates available to You. Updates may
          also modify or delete in their entirety certain features and
          functionality. You further acknowledge and agree that the Platform or
          portions thereof may not properly operate should You fail to have such
          Updates installed, and that all Updates will be deemed part of the
          Platform and be subject to all terms and conditions of this Agreement.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">7.</span>
        <span className="c0 c9">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span className="c10 c1 c11">Trademarks.</span>
      </p>
      <p className="c4">
        <span className="c6 c0">
          The Company name, service marks, slogans, logos, trade dress and other
          identifiers (&ldquo;Marks&rdquo;), including but not limited to, the
          terms &ldquo;theguarantors,&rdquo; &ldquo;guaranti,&rdquo; and
          &ldquo;securti,&rdquo; and &nbsp;are trademarks of the Company or its
          affiliates or licensors. You must not use such Marks without the prior
          written permission of the Company. All other names, logos, product and
          service names, designs, and slogans on this Platform are the
          trademarks of their respective owners.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">8.</span>
        <span className="c0 c9">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span className="c10 c11 c1">Third Party Materials or Services.</span>
      </p>
      <p className="c4">
        <span className="c0">
          The Platform may include software, content, data or other materials,
          including related documentation, that are owned by persons other than
          Company and that are provided to You on terms/obligations that are in
          addition to and/or different from those contained in this Agreement.
          Specifically, by using certain features in the Platform, You will be
          utilizing the services of Covie, a third-party service provider of
          Company. Covie is a software provider whose offerings assist with the
          functionality and verification offerings used in Company&rsquo;s
          Platform. By using our Platform, You are bound by Covie&rsquo;s
        </span>
        <span className="c0">
          <a
            className="c2"
            href="https://www.google.com/url?q=https://www.covie.com/legal/end-user-privacy&amp;sa=D&amp;source=editors&amp;ust=1687457092259196&amp;usg=AOvVaw2cIKvU6u5BYjzhLVTySzMN"
          >
            &nbsp;
          </a>
        </span>
        <span className="c10 c23">
          <a
            className="c2"
            href="https://www.google.com/url?q=https://www.covie.com/legal/end-user-privacy&amp;sa=D&amp;source=editors&amp;ust=1687457092259570&amp;usg=AOvVaw250qObb0oPBU6pLtFVbdTE"
          >
            Privacy Policy
          </a>
        </span>
        <span className="c6 c0">
          &nbsp;and any other applicable terms, which are incorporated by
          reference herein. Company does not warrant or guarantee the Covie
          services. We have no control over Covie or its services and accept no
          responsibility for them or for any loss or damage that may arise from
          Your use of them. If You decide to use our Platform and the Covie
          services, You do so entirely at Your own risk and subject to
          Covie&rsquo;s applicable terms and conditions of use.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">9.</span>
        <span className="c0 c9">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span className="c10 c11 c1">
          Collection and Use of Your Information.
        </span>
      </p>
      <p className="c4">
        <span className="c0">
          You acknowledge that when You access or use the Platform or certain of
          its features or its functionality, You will be asked to provide
          certain information about Yourself. All information we collect through
          or in connection with this Platform is subject to our
        </span>
        <span className="c0">
          <a
            className="c2"
            href="https://www.google.com/url?q=https://www.theguarantors.com/privacy&amp;sa=D&amp;source=editors&amp;ust=1687457092260172&amp;usg=AOvVaw1a-n1uCz_6F0N__ycSs4qV"
          >
            &nbsp;
          </a>
        </span>
        <span className="c10 c23">
          <a
            className="c2"
            href="https://www.google.com/url?q=https://www.theguarantors.com/privacy&amp;sa=D&amp;source=editors&amp;ust=1687457092260566&amp;usg=AOvVaw2AwMHSIBtChDUB10zhEtet"
          >
            Privacy Policy
          </a>
        </span>
        <span className="c6 c0">
          . By accessing, using and providing information to or through this
          Platform, You consent to all actions taken by us with respect to Your
          information in compliance with the Privacy Policy. Specifically, You
          permit Company to collect, retain, and use the information You provide
          via a PDF upload to provide the services outlined herein. You agree
          that Company may collect, retain, and use the data from that Covie
          gathers from Your insurer&rsquo;s application, webpage, or account,
          including policy information, to provide the services outlined herein.
          In addition, You permit Company to share all necessary information
          collected through Your use of the Platform with the relevant Landlord.
          Company will only provide the information necessary to provide the
          services. Company retains the right to use the information collected
          through its Platform or Covie for internal business purposes,
          including but not limited to Platform improvements.
        </span>
      </p>
      <p className="c20">
        <span className="c6 c0">
          If You sends or transmits any communications or materials to Company
          by mail, email, telephone, or otherwise, suggesting or recommending
          changes to the Company or Company&rsquo;s products or services,
          including without limitation, new features or functionality relating
          thereto, or any comments, questions, suggestions, or the like
          (&quot;Feedback&quot;), Company is free to use such Feedback
          irrespective of any other obligation or limitation between the Parties
          governing such Feedback. You hereby assigns to Company on Your behalf,
          all rights, titles, and interests in, and Company is free to use,
          without any attribution or compensation to any party, any ideas,
          know-how, concepts, techniques, or other intellectual property rights
          contained in the Feedback, for any purpose whatsoever, although
          Company is not required to use any Feedback.
        </span>
      </p>
      <p className="c3 c8">
        <span className="c0">10.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c11 c1">Updating Your Information.</span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          You are obligated to keep Your information up to date in the Platform.
          If You have a material change to Your insurance coverage or policy, a
          change in address, change in coverage amount, or change to Your
          insurance provider username and password, You are required to provide
          such updates by reentering your information into the Platform. You
          assume all liability that results from failure to keep Your
          information up to date. &nbsp;
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">11.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c1 c10">Enforcement.</span>
        <span className="c6 c1">&nbsp;</span>
      </p>
      <p className="c4">
        <span className="c6 c0">
          You hereby agree that any use of the Platform beyond the scope of this
          Agreement or other violation of the intellectual property rights of
          Company, shall constitute an infringement and that Company shall be
          entitled to preliminary and permanent injunctive relief enjoining and
          restraining further use of the Platform or violation of Company
          rights. You hereby consent to the issuance of such preliminary and
          permanent injunctive relief without the necessity for Company to prove
          irreparable harm and without the requirement that Company post a bond.
        </span>
      </p>
      <p className="c3 c8">
        <span className="c0">12.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c11 c1">Disclaimer of Warranties.</span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          You understand that Company cannot and does not guarantee or warrant
          that files available for downloading from the internet or the Platform
          will be free of viruses or other destructive code. You are responsible
          for implementing sufficient procedures and checkpoints to satisfy Your
          particular requirements for anti-virus protection and accuracy of data
          input and output, and for maintaining a means external to our site for
          any reconstruction of any lost data. TO THE FULLEST EXTENT PROVIDED BY
          LAW, COMPANY WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A
          DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES, OR OTHER
          TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER
          EQUIPMENT OR MOBILE DEVICE, PROGRAMS, DATA, OR OTHER PROPRIETARY
          MATERIAL DUE TO YOUR USE OF THE PLATFORMS OR ANY SERVICES OR ITEMS
          OBTAINED THROUGH THE PLATFORMS OR TO YOUR DOWNLOADING OF ANY MATERIAL
          POSTED ON IT, OR ON ANY PLATFORM LINKED TO IT.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          YOUR USE OF THE PLATFORMS, ITS CONTENT, AND ANY SERVICES OR ITEMS
          OBTAINED THROUGH THE PLATFORMS IS AT YOUR OWN RISK. THE PLATFORMS, ITS
          CONTENT, AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE PLATFORMS ARE
          PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo;
          BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
          NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED WITH THE COMPANY MAKES
          ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
          SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE
          PLATFORMS. WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR
          ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE
          PLATFORMS, ITS CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
          PLATFORMS WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED,
          THAT DEFECTS WILL BE CORRECTED, THAT OUR PLATFORMS OR THE SERVER THAT
          MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR
          THAT THE PLATFORMS OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
          PLATFORMS WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS, ACHIEVE ANY
          INTENDED RESULTS, BE COMPATIBLE, OR WORK WITH ANY OTHER SOFTWARE, OR
          APPLICATION.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          TO THE FULLEST EXTENT PROVIDED BY LAW, THE COMPANY HEREBY DISCLAIMS
          ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR
          OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
          MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED
          OR LIMITED UNDER APPLICABLE LAW.
        </span>
      </p>
      <p className="c3 c8">
        <span className="c0">13.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c11 c1">Limitation on Liability.</span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL THE COMPANY,
          ITS AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES,
          AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND,
          UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE,
          OR INABILITY TO USE, THE PLATFORMS, ANY PLATFORMS LINKED TO IT, ANY
          CONTENT ON THE PLATFORMS OR SUCH OTHER PLATFORMS OR APPLICATIONS,
          INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR
          PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY,
          PRODUCT LIABILITY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF
          REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS,
          LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY
          TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF
          FORESEEABLE.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          IN NO EVENT WILL THE COLLECTIVE LIABILITY OF THE COMPANY AND ITS
          SUBSIDIARIES AND AFFILIATES, AND THEIR LICENSORS, SERVICE PROVIDERS,
          EMPLOYEES, AGENTS, OFFICERS, AND DIRECTORS, TO ANY PARTY (REGARDLESS
          OF THE FORM OF ACTION, WHETHER IN CONTRACT, TORT, OR OTHERWISE) EXCEED
          $100.
        </span>
      </p>
      <p className="c3">
        <span className="c6 c0">
          THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED OR
          LIMITED UNDER APPLICABLE LAW.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">14.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c11 c1">Indemnification.</span>
      </p>
      <p className="c4">
        <span className="c6 c0">
          You agree to defend, indemnify, and hold harmless the Company, its
          affiliates, licensors, and service providers, and its and their
          respective officers, directors, employees, contractors, agents,
          licensors, suppliers, successors, and assigns from and against any
          claims, liabilities, damages, judgments, awards, losses, costs,
          expenses, or fees (including reasonable attorneys&rsquo; fees) arising
          out of or relating to (i) Your violation of these Terms and Conditions
          (ii) Your violation of any third-party right, including without
          limitation, any intellectual property right, publicity,
          confidentiality, property or privacy right; and/or (iii) Your
          violation of any laws, rules, regulations, codes, statutes, ordinances
          or orders of any governmental and quasi-governmental authorities,
          including, without limitation, all regulatory, administrative and
          legislative authorities. &nbsp;You will cooperate as fully required by
          Company in the defense of any claim. Company reserves the right to
          assume the exclusive defense and control of any matter subject to
          indemnification by You, and You will not in any event settle any claim
          without the prior written consent of Company. This Section shall
          survive the expiration or termination of this Agreement.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">15.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c11 c1">Limitation on Time to File Claims.</span>
      </p>
      <p className="c4">
        <span className="c0 c6">
          ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING
          TO THESE TERMS AND CONDITIONS OR THE PLATFORM MUST BE COMMENCED WITHIN
          ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES; OTHERWISE, SUCH CAUSE
          OF ACTION OR CLAIM IS PERMANENTLY BARRED.
        </span>
      </p>
      <p className="c3 c8">
        <span className="c0">16.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c11 c1">Geographic Restrictions</span>
      </p>
      <p className="c4">
        <span className="c6 c0">
          We are based in the State of New York in the United States. We provide
          this Platform for use only by persons located in the United States. We
          make no claims that the Platform or any of its content is accessible
          or appropriate outside of the United States. Access to the Platform
          may not be legal by certain persons or in certain countries. If You
          access the Platform from outside the United States, You do so on Your
          own initiative and are responsible for compliance with local laws.
        </span>
      </p>
      <p className="c4 c8">
        <span className="c0">17.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c11 c1">Entire Agreement.</span>
      </p>
      <p className="c4">
        <span className="c6 c0">
          This Agreement constitutes the entire agreement between the parties
          with respect to the Platform (as defined herein), sets forth
          Company&rsquo;s entire liability and Your exclusive remedy with
          respect to the Platform, and supersedes the terms of any purchase
          orders and any other communications or advertising with respect to the
          Platform. You acknowledge that this Agreement is a complete statement
          of the agreement between You and Company with respect to the Platform
          and that there are no other prior or contemporaneous understandings,
          promises, representations, or descriptions with respect to the
          Platform.
        </span>
      </p>
      <p className="c4">
        <span className="c0">18.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c1">Headings</span>
        <span className="c1">.</span>
        <span className="c6 c0">
          &nbsp;Headings under this Agreement are intended only for convenience
          and shall not affect the interpretation of this Agreement.
        </span>
      </p>
      <p className="c4">
        <span className="c0">19.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c1">Waiver and Modification.</span>
        <span className="c1">&nbsp;</span>
        <span className="c6 c0">
          No failure of either party to exercise or enforce any of its rights
          under this Agreement will act as a waiver of those rights. This
          Agreement may only be modified, or any rights under it waived, by a
          written document executed by the party against which it is asserted.
        </span>
      </p>
      <p className="c4">
        <span className="c0">20.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c1">Assignment</span>
        <span className="c1">.</span>
        <span className="c6 c0">
          &nbsp;You may not assign this Agreement or any right under or interest
          in this Agreement or delegate any obligations under this Agreement
          without the prior written approval of Company.
        </span>
      </p>
      <p className="c4">
        <span className="c0">21.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c1">Severability</span>
        <span className="c1">.</span>
        <span className="c6 c0">
          &nbsp;If any provision of this Agreement is found illegal or
          unenforceable, it will be enforced to the maximum extent permissible,
          and the legality and enforceability of the other provisions of this
          Agreement will not be affected.
        </span>
      </p>
      <p className="c4">
        <span className="c0">22.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c1">Representations</span>
        <span className="c1">.</span>
        <span className="c6 c0">
          &nbsp;You represent and warrant that You are authorized to enter into
          this Agreement and comply with its terms. Furthermore, You represent
          and warrant that You will at any and all times meet Your obligations
          hereunder, as well as comply with any and all laws, regulations and
          policies that may apply to the use of the Platform.
        </span>
      </p>
      <p className="c4">
        <span className="c0">23.</span>
        <span className="c0 c9">&nbsp; </span>
        <span className="c10 c1">Governing Law</span>
        <span className="c1">.</span>
        <span className="c6 c0">
          &nbsp;This Agreement shall be interpreted and construed in accordance
          with the laws of the State of New York, without regard to its
          conflicts of laws provisions. Any dispute, claim or controversy
          arising out of or relating to this Agreement or the breach,
          termination, enforcement, interpretation or validity thereof,
          including the determination of the scope or applicability of this
          provision to arbitrate shall be determined by arbitration in the State
          of New York. &nbsp;The arbitration shall be confidential, to extent
          permitted by law, and administered by a mutually agreed upon
          arbitration service provider, pursuant to that arbitration service
          provider&rsquo;s rules and procedures, or to the extent an arbitration
          service provider cannot be mutually agreed to, it shall be
          administered by the American Arbitration Association under its
          Commercial Arbitration Rules then in effect. &nbsp;Judgment on the
          Award, if any, may be entered in any court having jurisdiction and/or
          in a court of competent jurisdiction. &nbsp;This provision may be
          waived only upon written stipulation between the parties. To extent
          Parties waive mandatory arbitration, pursuant to this Section 23, each
          Party irrevocably and unconditionally submits to the exclusive
          jurisdiction of the State and Federal courts located in New York, New
          York, for any action, litigation or proceeding arising from or
          relating to this Agreement.
        </span>
      </p>
      <p className="c27">
        <span className="c6 c22"></span>
      </p>
      <div>
        <p className="c12">
          <span className="c6 c7"></span>
        </p>
        <hr />
        <p className="c12">
          <span className="c6 c7"></span>
        </p>
        <p className="c12">
          <span className="c6 c7"></span>
        </p>
        <Grid container>
          <Grid item xs={12} sm={6} marginY={1}>
                <span className="c5 c13">theguarantors.com</span>
          </Grid>
          <Grid item xs={12} sm={6} marginY={1}>
                <span className="c13 c24">
                  One World Trade Center, New York, NY 10007 |
                </span>
                <span className="c13 c24">
                  {` `}(212) 266-0020
                </span>
          </Grid>
        </Grid>
        <p className="c12">
          <span className="c6 c7"></span>
        </p>
      </div>
    </>
  );
};
